export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">
          了解夜猫电影院的初心与使命
        </p>

        <div className="bg-background-50 border border-background-200/60 rounded-2xl p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-movie-2-line text-primary-600 text-2xl"></i>
          </div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            夜猫电影院成立于2023年，是一家专注于高清电影免费在线观看的影视平台。我们深知每一位深夜追剧人的需求——不卡顿、不缓冲、高清画质、秒播体验。平台汇聚超过10万部影片，涵盖最新电影、经典老片、热门电视剧、综艺动漫等全品类内容，致力于为广大影视爱好者打造最好用的免费影院。每日更新片源，实时同步院线新作，让熬夜看剧变成一种享受而非煎熬。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">3年</div>
              <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活用户</div>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">0广告</div>
              <div className="text-xs text-foreground-500 mt-1">纯净观影</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}